import { useQuery } from "@tanstack/react-query";
import {
  getClientRegistrationData,
  getPlatformUser,
} from "@/api/v1-jwt/tenancy/tenancy";
import { useAuth } from "@/providers/auth";
import { usePlatformData } from "../platform/use-platform-data";

export const useClientRegistration = ({
  registrationId,
  queryKey,
  queryFn,
  enabled,
  ...config
} = {}) => {
  let { data, isLoading } = usePlatformData();

  return useQuery({
    queryKey: ["tenancy", "registration", registrationId],
    queryFn: async () =>
      getClientRegistrationData({
        platformId: data?.platform_id,
        registrationId,
      }),
    enabled: !!data?.platform_id && !!registrationId,
    staleTime: Infinity,
    ...config,
  });
};
